module.exports = __webpack_public_path__ + "static/img/ent-detail-39.668c9f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-39.jpg
// module id = ilAi
// module chunks = 51